module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABQUlEQVQ4y42TwXHCMBBFH24AUgGkgriDmArgEjMTDkAHyeScidMASSoIHHSQTk4FgQ5MBYEO7ArI5WtG8QhP9iLvavf/7y+pdz6fiUU+m2dBenTWHGN9vRAgn81HQAEsIr0HoHDWlFGAfDZfAu9AX3snwLPeBjNbZ83yD4Dkfqu2l4oaGKj2A6yAlzZI7y6/HwAVMAS2UlEq99EEoJ+qjZ01uwSYqvkErIFdaxj91psUvapWeAUlMAEegfSCgaGSm8CbqwQYKamAjO7oA9c6EYA0BDhGpF+K2n8kYkbyD/8c9qR1CDDVCXTFXkYOgcZZUyXARpsLgW07DHwOSEqAxFlTAV8q7gS4Epu/wh9y/0lrAzx4DwCWauzrRmZiGqux1v5Ew1NnTd1+CwOxTzo8OGm4ir5GAaVSlLacL501mzbiL5XZc4VcekZRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_ubicacion.png
// module id = 167
// module chunks = 0